import React from 'react'

import { IMaskInput } from 'react-imask'
import classNames from 'classnames'
import { useField } from 'formik'

import { FieldError } from '@components/form'
import { FieldProps } from '@components/form/types'

import styles from '../../styles.module.scss'

type InputMaskProps = FieldProps & {
  id?: string
  mask: string
  className?: string
  placeholder?: string
  disabled?: boolean
  readOnly?: boolean
  tabIndex?: number
  onlyNumbers?: boolean
}

export const InputMask = ({
  name,
  label,
  className,
  container,
  error,
  mask,
  onlyNumbers = false,
  withoutError = false,
  ...rest
}: InputMaskProps) => {
  const [field, meta, helpers] = useField<string>(name)

  const handleAccept = (value: string) => {
    let cleanValue = value
    if (onlyNumbers) {
      cleanValue = value.replace(/[^0-9-.]+/g, '')
    } else {
      cleanValue = value.replace(/_/g, '')
    }
    helpers.setValue(cleanValue)
  }

  return (
    <div {...container}>
      {label}
      <IMaskInput
        mask={mask}
        value={field.value}
        onAccept={handleAccept}
        onBlur={() => helpers.setTouched(true)}
        className={classNames(styles.input, className, {
          [styles.error]: meta.error && meta.touched
        })}
        {...rest}
      />
      {!withoutError && (
        <FieldError touched={meta.touched} error={meta.error} {...error} />
      )}
    </div>
  )
}
